import { createServerFn } from "@tanstack/react-start";
import { getRequest } from "@tanstack/react-start/server";
import { eq } from "drizzle-orm";
import { db } from "~/db";
import { auth } from "~/lib/better-auth/auth";
import { userBillingProfile } from "~/db/schema";

export const getUserBillingProfile = createServerFn({ method: "GET" }).handler(
  async () => {
    const request = getRequest();

    if (!request?.headers) {
      return null;
    }

    const userSession = await auth.api.getSession({ headers: request.headers });

    if (!userSession) {
      return null;
    }

    const [profile] = await db
      .select()
      .from(userBillingProfile)
      .where(eq(userBillingProfile.userId, userSession.user.id))
      .limit(1)
      .execute();

    if (!profile) {
      return null;
    }

    return profile;
  }
);

